module.exports = __webpack_public_path__ + "static/media/sector-3.c1a646f2.jpg";